import { EyeOutlined } from "@ant-design/icons";
import { Image } from "antd";

type Props = {
  thumbnail: string | undefined;
  legend: string;
  size?: number;
};

export const ImagePreviewCell = ({ thumbnail, legend, size }: Props) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Image
        src={thumbnail}
        width={size ?? 32}
        height={size ?? 32}
        preview={{
          mask: (
            <div style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
              <EyeOutlined />
            </div>
          ),
        }}
      />
      <span style={{ marginLeft: "10px" }}>{legend}</span>
    </div>
  );
};
